import { createFileRoute } from '@tanstack/react-router'
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy'
import PublicLayout from '../layouts/PublicLayout'

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicyComponent,
})

function PrivacyPolicyComponent() {
  return (
    <PublicLayout>
      <PrivacyPolicy />
    </PublicLayout>
  )
}
